import { Modal } from "./Modal.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";
import { PmDRSDatalayer } from "../Datalayer/PmDRSDatalayer.js";
import { FormatHelper } from "../Helpers/FormatHelper.js";

export class ContactFormSection {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAtt = "contact-form-section";
        this.enabled = true;
        this.consents = null;//it'll pull from dealersite
        this.shiftFormErrorSent = false;
    }

    init(containerElement) {
        var $this = this;
        containerElement.insertAdjacentHTML("beforeend", this.getHtml());
        // this.changeTitles();
        let isMotosAmerica = this.app.config.vehicle.make.toLowerCase() == "ducati";
        // step 1 confirmation modal
        this.confirmationModal = new Modal(
            this.app,
            "start-contact-confirmation",
            this.getModalHtml(),
            null,
            "contact-confirmation-class"
        );
        this.confirmationModal.init();
        this.confirmationModal.setHideCallback(() => this.continueAfterContactSubmit());

        this.setTCPA_CCPA();
        this.eventHandlers();
        this.addSubmissionFormImg();
        this.hideImage();
        this.setPrivacyPolicyLink();
        this.prefillFromStoredContactInfo();
    }

    // Re-selects the chosen payment box and scrolls to the next section. Ran when the step 1
    // "Thank You" modal closed; that modal is no longer shown, so it now runs right after submit.
    continueAfterContactSubmit() {
        let background = this.app.config.vehicle.make.toLowerCase() == "indian motorcycle" ? "indian-background" : "bmw-background";
        let dealType = this.app.dealPage.dealType;
        DOMHelper.removeClass(this.app.getSelector(".payment-option-box.active"), background);
        DOMHelper.removeClass(this.app.getSelector("#your-payment-section .easy-ride-box"), "active");
        DOMHelper.removeClass(this.app.getSelector("#your-payment-section .finance-box"), "active");
        switch (dealType) {
            case 'balloon':
                DOMHelper.addClass(this.app.getSelector("#your-payment-section .easy-ride-box"), "active");
                break;

            case 'finance':
                DOMHelper.addClass(this.app.getSelector("#your-payment-section .finance-box"), "active");
                break;

            case 'premier':
                DOMHelper.addClass(this.app.getSelector("#your-payment-section .premier-box"), "active");
                break;

            case 'ttf':
                DOMHelper.addClass(this.app.getSelector("#your-payment-section .ttf-box"), "active");
                break;
            default:
                break;
        }
        // if (this.app.isBMW()) {
        //     DOMHelper.addClass(this.app.getSelector("#your-payment-section .easy-ride-box"), "active");
        // } else if (this.app.isBMWPolaris() && !isMotosAmerica) {
        //     DOMHelper.addClass(this.app.getSelector("#your-payment-section .finance-box"), "active");
        // } else if (isMotosAmerica) {
        //     DOMHelper.addClass(this.app.getSelector("#your-payment-section .premier-box"), "active");
        // }
        DOMHelper.addClass(this.app.getSelector(".payment-option-box.active"), background);
        this.app.dealPage.jumpToSecondSection();
    }

    // The dealer's privacyPolicyUrl setting, else the dealer site's own /privacy-policy/ page
    setPrivacyPolicyLink() {
        let link = document.querySelector(this.getSelector('.privacy-policy-link'));
        if (link) link.href = this.app.siteSettings.privacyPolicyUrl || (window.location.origin + "/privacy-policy/");
    }

    // Tab-scoped, not localStorage — cleared when the browser tab closes rather than
    // persisted forever, since this is a same-visit convenience prefill, not a record.
    getStoredContactInfoKey() {
        return "pmdrs_last_contact_" + this.app.pmdrs.config.accountId;
    }

    // Convenience prefill only — never blocks or disables the submit button, so a
    // returning customer can always submit again, exactly like a fresh start.
    prefillFromStoredContactInfo() {
        let stored;
        try {
            stored = JSON.parse(sessionStorage.getItem(this.getStoredContactInfoKey()));
        } catch (e) {
            return;
        }
        if (!stored) return;

        let fields = {
            ".ciFirstName": stored.firstname,
            ".ciLastName": stored.lastname,
            ".ciEmail": stored.email,
            ".ciMobileNumber": stored.phoneNumber,
            ".ciZipCode": stored.zipCode,
        };
        Object.keys(fields).forEach((selector) => {
            let value = fields[selector];
            if (!value) return;
            let elem = document.querySelector(this.getSelector(selector));
            if (elem) elem.value = value;
        });
    }

    persistContactInfo() {
        let getValue = (selector) => {
            let elem = document.querySelector(this.getSelector(selector));
            return elem ? elem.value : "";
        };
        let contactInfo = {
            firstname: getValue(".ciFirstName"),
            lastname: getValue(".ciLastName"),
            email: getValue(".ciEmail"),
            phoneNumber: getValue(".ciMobileNumber"),
            zipCode: getValue(".ciZipCode"),
        };
        try {
            sessionStorage.setItem(this.getStoredContactInfoKey(), JSON.stringify(contactInfo));
        } catch (e) {
            // sessionStorage unavailable (private browsing, etc.) — prefill is a
            // convenience, not a requirement, so silently skip persisting it.
        }
    }

    changeTitles() {
        let siteToken = this.app.pmdrs.config.accountId;
        if (siteToken != "gotorcauto") return;

        let formTitle = this.getSelector(".contact-form-title");
        DOMHelper.setTextContent(formTitle, "Complete this form to save your work");
        let formSubmitBtn = this.getSelector(".contact-form-button");
        DOMHelper.setValue(formSubmitBtn, "Save and Continue");
    }

    setBackground(make) {
        let background = "";
        background = make.toLowerCase() == "indian motorcycle" ? "indian-background" : "bmw-background";
        // Header redesign: .header-info-section no longer gets the account's
        // branded fill — it's always the new flat white/Manrope look.
        DOMHelper.addClass(this.getSubmitBtn(), background);
        DOMHelper.addClass(document.querySelector(this.app.getSelector(".contact-confirmation-btn")), background);
    }

    hideImage(){
        const noImageSites = ['fresnochryslerjeep', 'clovischryslerdodgejeepram', 'ironmountainjeep', 'escanabadodge', 'marinettedodge'];

        if(noImageSites.includes(this.app.pmdrs.config.accountId)){
            DOMHelper.addClass(this.app.getSelector(".img-submission-form"), 'd-none')
        }
    }

    eventHandlers() {
        var $this = this;
        DOMHelper.addHandler(this.app.getSelector(".continue-btn"), "click", () => {
            $this.confirmationModal.hide();
        });

        // Method for Preferred Method of Contact
        let contactMethodEvent = function () {
            let selectValue = document.querySelector($this.getSelector(".contact-contact-method")).value;
            let tcpa = document.querySelector($this.getSelector("#tcpa-description"));
            let ccpa = document.querySelector($this.getSelector("#ccpa-description"));
            switch (selectValue) {
                case "Phone":
                case "Text Messages":
                    tcpa.style.display =
                        ccpa.style.display =
                            "inline";
                    break;

                // Same keys as the dealer site's pmGetDescriptions: #tcpa-* is the text-message/autodialer
                // consent ("not required as a condition of purchase"), #ccpa-* the general "may contact me"
                // one. An Email contact only needs the general one.
                case "Email":
                    ccpa.style.display = "inline";
                    tcpa.style.display = "none";
                    break;

                default:
                    tcpa.style.display =
                        ccpa.style.display =
                            "none";
                    break;
            }
        };
        document
            .querySelector($this.getSelector(".contact-contact-method"))
            .addEventListener("change", contactMethodEvent);

        //SUBMIT
        DOMHelper.addHandler(this.getSubmitBtn(), "click", (e) => {
            e.preventDefault();

            var isValid = $this.validateContactInformation();
            if (isValid) {
                $this.submitContactInformation();
            }
        });
    }

    getHtml() {
        return `<div class="trigger-element" data-index="4"></div>
<div class="contact-form-section deal-page-section">
    <div class="notification-section-area">
    <p class="notification-federal-tax-text">$7,500 Federal Tax Credit</p>
    <p class="notification-msg">The 
        <span class="notification-year"></span>
        <span class="notification-make"></span>
        <span class="notification-model"></span>
        qualify for a federal tax credit for elegible buyers. This credit amount is in effect for deliveries until March 2023.
        <span><a href="#" id="see-details-notification-section">See Details</a></span>
    </p>
</div>
    <div class="contact-form-title">Contact Information</div>
    <div class="contact-form-subtitle">* Required</div>
    <div class="contact-form">
    <!-- <form class="contact-form"> -->
        <div class="contact-form-group">
    <label class="contact-form-label">First Name *
        <span></span>
    </label>
    
    <input class="contact-form-input ciFirstName"
    @@multiple type="text"
    accept="@@accept"
    name="firstField"
    placeholder="" required
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input firstField">This field is required.</p>
    <p class="description"></p>
</div>


        <div class="contact-form-group">
    <label class="contact-form-label">Last Name *
        <span></span>
    </label>
    
    <input class="contact-form-input ciLastName"
    @@multiple type="text"
    accept="@@accept"
    name="lastField"
    placeholder="" 
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input lastField">This field is required.</p>
    <p class="description"></p>
</div>


        <div class="contact-form-group">
    <label class="contact-form-label">Email *
        <span></span>
    </label>
    
    <input class="contact-form-input ciEmail"
    @@multiple type="email"
    accept="@@accept"
    name="emailField"
    placeholder="" 
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input emailField">This field is required.</p>
    <p class="description"></p>
</div>


        <div class="contact-form-group">
    <label class="contact-form-label">Mobile Number *
        <span></span>
    </label>
    
    <input class="contact-form-input ciMobileNumber"
    @@multiple type="text"
    accept="@@accept"
    name="phoneField"
    placeholder="" 
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input phoneField">This field is required.</p>
    <p class="description"></p>
</div>


        <div class="contact-form-group">
    <label class="contact-form-label">ZIP Code *
        <span></span>
    </label>
    
    <input class="contact-form-input ciZipCode"
    @@multiple type="text"
    accept="@@accept"
    name="zipCodeField"
    placeholder="" 
    maxlength="10" inputmode="numeric">

    <p class="error-input zipCodeField">This field is required.</p>
    <p class="description"></p>
</div>


        <div class="contact-form-group preferred-method-field">
    <label class="contact-form-label-pmc">Preferred Method of Contact *</label>
    <label for="contact-method-error" class="error-preferred-method-inline">This field is required</label>
    <select class="contact-form-input contact-contact-method" type="text" name="preferredmethodofcontactField">
        <option value="default" disabled="" selected="">Select a Preferred Method</option>
        <option value="Phone">Phone</option>
        <option value="Email">Email</option>
        <option value="Text Messages">Text Messages</option>
    </select>
</div>
<!-- for= on the consent labels: old pm-flex-theme generalFormFix() turns every label without one into a plain
     <div>, dropping the checkboxes and our classes (josedemo still runs it) -->
<label for="required-tcpa" class="error-preferred-method">This field is required</label>
<div class="contact-form-group">
    <label class="checkbox-label ccpa-description" id="ccpa-description" for="ccpa-checkbox" style="display: none;">
        <input type="checkbox" id="ccpa-checkbox" name="ccpa-checkbox" value="HTML" style="margin-right:7px;" />
        <span>
        *By submitting this form I understand that this site may contact me with offers or information about their products and service.
        </span>
    </label>
</div>
<div class="contact-form-group">    
    <label class="checkbox-label tcpa-description" id="tcpa-description" for="tcpa-checkbox" style="display: none;">
        <input type="checkbox" id="tcpa-checkbox" name="tcpa-checkbox" value="HTML" style="margin-right:7px;" />
        <span>
        *By checking here, I direct this site to send me text messages to market or advertise products, goods, or services. These text messages may be transmitted through autodialed calls or robotext. By checking the checkbox and
        clicking submit, I confirm that I am the current owner/subscriber of the mobile number provided or that the current owner/subscribed of this mobile phone number authorized me to provide this number to the dealer. I
        understand that my consent is not required as a condition of purchase and that I can revoke my consent at any time. My carrier wireless and text message fees may apply. I will contact the dealer directly to provide
        reasonable notice if I no longer wish to receive automated calls or texts.
        </span>
    </label>

</div>
        
        <input type="button" value="Finish & Send" class="contact-form-button" />
        <div class="contact-form-footer">
            By submitting, you agree that the dealer may contact you about this vehicle and its financing using the contact method you selected. Consent to receive automated calls or text messages is given only through the checkbox above and is not a condition of purchase.
            <a href="#" class="privacy-policy-link" target="_blank">Privacy Policy</a>
        </div>
    </div>
    <!-- </form> -->
</div>
   `;
    }

    getModalHtml() {
        return `<div class="start-contact-confirmation">
    <div class="confirmation-header">
    </div>
    <div class="body">
        <p class="thank-you">Thank You</p>
        <img class="img-submission-form" src="" alt="">
        <div class="steps">
            
        </div>
        <p class="text-body">Your contact information was received.</p>
        <button class="color-white continue-btn contact-confirmation-btn" type="button">Continue</button>
    </div>
</div>`;
    }

    updateModalInfo(firstName, lastName, msg) {
        let thankYou = document.querySelector(this.app.getSelector(".thank-you"));
        let txtbody = document.querySelector(this.app.getSelector(".text-body"));
        thankYou.innerHTML = "Thank You " + firstName + " " + lastName;
        txtbody.innerHTML = msg;

        if (false) {
            //no steps
            let steps = document.querySelector(this.app.getSelector(".steps"));
            steps.innerHTML = this.app.dealPage.stepper.addStepNumbers();

            let li = document.querySelector(this.app.getSelector(".steps li:first-of-type"));
            li.classList.add("pmdrs-fa");
            li.classList.add("pmdrs-fa-check");

            let nextLi = document.querySelector(this.app.getSelector(".steps li.step-btn[data-index_target='1']"));
            let totalLi = document.querySelectorAll(this.app.getSelector(".steps li.step-btn"));
            let target = nextLi.dataset.index_target;
            let totalParts = totalLi.length * 2;

            let width = ((target * 2 + 1) / totalParts) * 100;
            let value = "calc(" + (width + "%") + " - 25px)";
            console.log(nextLi, totalLi, target, totalParts, width, value);
            let arrow = document.querySelector(this.app.getSelector(".line.arrow-right"));
            arrow.style.setProperty("--left", value);

            let line = document.querySelector(this.app.getSelector("#line"));
            // line.style.left = "12%";
            if (totalLi.length == 3) line.style.width = "76%";
            let lineProgress = document.querySelector(this.app.getSelector("#line #line-progress"));

            target = nextLi.dataset.index_target;
            totalParts = totalLi.length - 1;
            width = (target / totalParts) * 100;
            lineProgress.style.width = "calc(" + (width + "%") + " - 0px)"; //was 18 for the arrow
        }

        this.confirmationModal.show();
    }

    showError(domElement) {
        return (domElement.nextElementSibling.style.display = "block");
    }

    hideError(domElement) {
        return (domElement.nextElementSibling.style.display = "none");
    }

    saveLead(formData) {
        let accessoriesField = [];
        let accessoriesSelected = document.querySelectorAll(this.getSelector(".accessory-selected"));

        let creditscoreStr = this.app.dealPage.paymentSection.getCurrentCreditScoreRangeStr();
        formData.set("creditscoreField", creditscoreStr);
        // omit rather than send "0"/"null" when no valuation ever ran, so a genuine $0
        // appraisal stays distinguishable from "customer never ran a valuation"
        if (this.app.dealPage.tradeInValue !== null) {
            formData.set('tradeInValueField', this.app.dealPage.tradeInValue);
        }

        accessoriesSelected.forEach((selected) => {
            let img = selected.querySelector(".accessory-img");
            let id = img.dataset.id;
            let acc = this.app.dealPage.getAccessoryById(id);
            if(!acc){
                console.error("Accessory not found, please investigate id: " + id);
                return;
            }

            if (acc.product_type == "package") {
                let accs = acc.accessories;
                Object.keys(accs).forEach((accKey) => {
                    let accessory = {
                        id: accs[accKey]._id,
                        title: accs[accKey].name,
                        price: accs[accKey].price,
                        sku: accKey,
                    };
                    accessoriesField.push(accessory);
                });
            } else {
                let accessory = {
                    id: img.dataset.id,
                    title: img.dataset.title,
                    price: img.dataset.price,
                    sku: img.dataset.sku,
                };
                accessoriesField.push(accessory);
            }
        });
        formData.set("accessoriesField", JSON.stringify(accessoriesField));

        let tradeInVehicle = null;
        if (this.app.dealPage.getTradeInEnable()) {
            this.app.dealPage.tradeInSection.imagesTradeIn.forEach((image) => {
                formData.append("vehicleImages[]", image);
            });

            let year = document.querySelector(this.app.dealPage.tradeInSection.getSelector(".tradeYearField"));
            let make = document.querySelector(this.app.dealPage.tradeInSection.getSelector(".tradeMakeField"));
            let model = document.querySelector(this.app.dealPage.tradeInSection.getSelector(".tradeModelField"));
            let trim = document.querySelector(this.app.dealPage.tradeInSection.getSelector(".tradeTrimField"));
            formData.set("tradeYearField", year.value);
            formData.set("tradeMakeField", make.value);
            formData.set("tradeModelField", model.value);
            formData.set("tradeTrimField", trim.value);

            tradeInVehicle = {
                make: make.value,
                model: model.value,
                year: year.value,
            };

            //DATALAYER trade in
            this.app.shiftDatalayer.fireEvent('drTradeInFinish')
        }

        // ADD TAXES
        if (this.app.dealPage.paymentSection.isUsingTaxes()) {
            let taxesList = this.app.dealPage.paymentSection.getFeesAndTaxesList();
            if (taxesList) {
                for (let index = 0; index < taxesList.length; index++) {
                    const taxesItem = taxesList[index];
                    formData.set(`taxes[${index}][label]`, taxesItem.label);
                    formData.set(`taxes[${index}][amount]`, taxesItem.amount);
                }
            }
        }

        let sessionVars = this.app.pmdrs.config.hostSessionVars;
        let pmOffer = {
            pmOfferId: sessionVars.pmOfferid,
            adId: sessionVars.sd_adid
        };
        if (sessionVars.pmOfferid != null && sessionVars.sd_adid != null) {
            formData.set("pmOffer", JSON.stringify(pmOffer));
        }

        formData.set("drsCustomerStatus", "complete");
        let emailField = formData.get('emailField');

        this.app.pmdrs.pmApiDtm.postLead(
            formData,
            (response) => {
                console.log(JSON.parse(response));
                this.app.dealPage.hideLoading();
                this.persistContactInfo();
                // Blocks resubmission the moment the lead is actually saved — the thank-you
                // modal alone didn't stop a customer from clicking "Finish and Send" multiple
                // times before dismissing it (confirmed: 3 clicks produced 3 separate leads).
                // setSubmitBtnSent()/disable() already existed for exactly this, just unused
                // since the legacy postLead flow was replaced by saveLead().
                this.setSubmitBtnSent();
                this.disable();
                if (this.app.siteSettings.contactFormAtBottom) {
                    if (this.app.dealPage.paymentSection.makeDownPayment) {
                        this.app.dealPage.thankYouModal.updateSecondaryMessage(this.app.dealPage.paymentSection.downPaymentDeposit);
                    }
                    this.app.dealPage.thankYouModal.submissionModal.show();
                    this.app.dealPage.showAdditionalStepsInfo();
                }

                this.app.pmdrs.pmCustomerAPI.saveCustomer(formData, (response) => {
                    response = JSON.parse(response);
                    console.log("Customer save response");
                    console.log(response);
                    this.app.dealPage.drsCustomerId = response.id;
                    let CJData = {
                        sessionId: this.app.pmDRSDatalayer.getSessionId(),
                        siteToken: this.app.pmdrs.config.accountId,
                        customerId: this.app.dealPage.drsCustomerId,
                        leadId: this.app.dealPage.leadId,
                        CJId: this.app.dealPage.customerJourneyId
                    };
                    this.app.pmdrs.pmCustomerAPI.createCustomerJourney(CJData, 
                        (data) => {
                            let journey = JSON.parse(data);
                            this.app.dealPage.customerJourneyId = journey.id;
                        },
                        (error) => {
                            console.log(error);
                    });
                });
                // DATALAYER
                this.app.shiftDatalayer.fireEvent('formSubmission', {
                    formType: 'Other',
                    leadId:this.app.dealPage.ftid
                });
                this.app.pmDRSDatalayer.submitEvent(PmDRSDatalayer.CONTACT_INFO_SECTION,
                    'submit button',
                    this.getSubmitBtn(),
                    this.app.dealPage.leadId, this.app.config.vehicle);
                this.setSubmitBtnSent();

                // Enable sections and disable the contact form now that it's submitted
                this.app.dealPage.enableSections();
                this.disable();
                // No "Thank You" modal for the contact form at the top: go straight to the next section
                if (!this.app.siteSettings.contactFormAtBottom) {
                    this.continueAfterContactSubmit();
                }
                if (this.app.pmdrs.dataDriver.isLenderDesk()) {
                    // LenderDesk rates depend on the customer's zip code — refresh now that it's been submitted
                    this.app.dealPage.paymentSection.refreshAllPayments();
                    this.app.dealPage.showZipCodeDisclaimer();
                }

                this.app.pmdrsForms.stellantisHashEmail(emailField)
                    .then((hashedEmail) =>{
                        this.app.adobeDtmDatalayer.fireEvent('formSubmit', {
                            formType: 'contact-information',
                            leadId:this.app.dealPage.ftid,
                            hashedEmail,
                            tradeInVehicle: this.app.dealPage.tradeInSection?.includeTradeIn? tradeInVehicle : null
                        });
                    });
            }
        );
    }

    submitContactInformation() {
        console.log("***** ***** ***** ***** MESSAGE FROM CONTACT FORM SECTION ***** ***** ***** *****");
        this.app.dealPage.showLoading();
        var formData = new FormData(document.querySelector(this.app.getSelector(".deal-page-form")));
        formData.set("leadId", this.app.dealPage.leadId);
        formData.set("ftid", this.app.dealPage.ftid);
        formData = this.app.dealPage.addExtraFormData(formData);
        let emailField = formData.get('emailField');

        // Stripe Payment, then save the lead
        if (this.app.dealPage.paymentSection.makeDownPayment) {
            this.app.dealPage.paymentSection.processPayment((paymentIntent) => {
                this.app.dealPage.stripePaymentId = paymentIntent.id;
                this.saveLead(formData);
            })
        } else {
            // only save the lead
            this.saveLead(formData);
        }

        /* LEGACY FLOW — kept as reference (unreachable, superseded by saveLead())
        this.app.pmdrs.pmApiDtm.postLead(
            formData,
            (response) => {
                console.log(JSON.parse(response));
                this.app.dealPage.hideLoading();

                this.showThankYouForm();

                //ENABLE SECTIONS
                this.app.dealPage.enableSections();

                //DISABLE THIs SECTION
                this.setSubmitBtnSent();
                this.disable();
                if(this.app.pmdrs.dataDriver.isLenderDesk()){
                    this.app.dealPage.paymentSection.refreshAllPayments();
                    this.app.dealPage.showZipCodeDisclaimer();
                }

                // DATALAYER
                this.app.shiftDatalayer.fireEvent('formSubmission', {
                    formType: 'Other',
                    leadId:this.app.dealPage.ftid
                });
                this.app.pmDRSDatalayer.submitEvent(PmDRSDatalayer.CONTACT_INFO_SECTION,
                    'submit button',
                    this.getSubmitBtn(),
                    this.app.dealPage.leadId, this.app.config.vehicle);

                this.app.pmdrsForms.stellantisHashEmail(emailField)
                    .then((hashedEmail) =>{
                        this.app.adobeDtmDatalayer.fireEvent('formSubmit', {
                            formType: 'contact-information',
                            leadId:this.app.dealPage.ftid,
                            hashedEmail
                        });
                    });
            },
            (error) => {
                console.log(error);
            }
        );

        // CUSTOMER STATUS + SAVE CUSTOMER (was outside postLead callback — race condition in original)
        formData.set("drsCustomerStatus", "partial");
        if (this.app.dealPage.drsCustomerId.length > 0) {
            formData.set("drsCustomerStatus", "complete");
        }
        let sessionVars = this.app.pmdrs.config.hostSessionVars;
        let pmOffer = {
            pmOfferId: sessionVars.pmOfferid,
            adId: sessionVars.sd_adid
        };
        console.log(sessionVars);
        if (sessionVars.pmOfferid != null && sessionVars.sd_adid != null) {
            formData.set("pmOffer", JSON.stringify(pmOffer));
        }
        this.app.pmdrs.pmCustomerAPI.saveCustomer(formData, (response) => {
            response = JSON.parse(response);
            console.log("Customer save response");
            console.log(response);
            this.app.dealPage.drsCustomerId = response.id;
            let CJData = {
                sessionId: this.app.pmDRSDatalayer.getSessionId(),
                siteToken: this.app.pmdrs.config.accountId,
                customerId: this.app.dealPage.drsCustomerId,
                leadId: this.app.dealPage.leadId,
                CJId: this.app.dealPage.customerJourneyId
            };
            this.app.pmdrs.pmCustomerAPI.createCustomerJourney(CJData,
                (data) => {
                    let journey = JSON.parse(data);
                    this.app.dealPage.customerJourneyId = journey.id;
                },
                (error) => {
                    console.log(error);
            });
        });
        END LEGACY FLOW */
    }

    addSubmissionFormImg() {
        let formImg = document.querySelector(this.app.getSelector(".img-submission-form"));
        if (this.app.pmdrs.config.accountId == "delamomotorsports") {
            DOMHelper.addClass(formImg, 'd-none');
            return;
        }
        let isFCA = this.app.pmdrs.isFCA();
        let pmDrsUrl = this.app.pmdrs.pmApi.getRootURL();
        let isMotosAmerica = this.app.pmdrs.isMotosAmericaSite();
        let imgPath = "dist/img/BMW-river.webp";//default 

        if (this.app.isVehicleStellantis()) {//FCA
            imgPath = "dist/img/success1.webp";
        } else if (isMotosAmerica) {//MOTOS AMERICA
            if(this.app.isBMW()){
                imgPath = "dist/img/MOTOS_BMW_SUBMIT1.webp";
            } else if (this.app.isVehicleDucati()) {
                imgPath = "dist/img/MOTOS_DUCATI_SUBMIT1.webp";
            } else if (this.app.isVehicleTriumph()) {
                imgPath = "dist/img/MOTOS_TRIUMPH_SUBMIT1.webp";
            } 
        }else if (this.app.pmdrs.config.accountId == "sandiabmwmotorcycles"){//single site rule
            imgPath = "dist/img/SANDIA_BMW_SUBMIT1.webp";
        } else if (this.app.isVehiclePolaris()) {
            imgPath = "dist/img/PolarisGIF1.webp";
        } else if (this.app.isVehicleFord()) {
            imgPath = "dist/img/FordF150.gif";
        }  else if (this.app.isVehicleCanam()) {
            imgPath = "dist/img/canam1.png";
        } else if (this.app.isVehicleHarleyDavidson()) {
            imgPath = "dist/img/submit 1 370.gif";
        }
        
        formImg.dataset.src = pmDrsUrl + imgPath; // loaded when its modal opens (Modal.loadDeferredImages)
    }

    showThankYouForm() {
        let firstname = document.querySelector(this.getSelector(".ciFirstName")).value;
        let lastname = document.querySelector(this.getSelector(".ciLastName")).value;
        let msg = this.app.dealPage.accessoriesSection
            ? "Your contact information was received. Next, you can add accessories and configure your payment."
            : "Your contact information was received. Next, you can configure your payment.";

        this.updateModalInfo(firstname, lastname, msg);
    }

    getCustomerZipCode() {
        let zipCodeElem = document.querySelector(this.getSelector(".ciZipCode"));
        return zipCodeElem.value;
    }

    validateContactInformation() {
        let validPhoneNumber = false;
        let validPreferred = false;
        let validLength = true;
        let validEmail = false;
        let firstNameElem = document.querySelector(this.getSelector(".ciFirstName"));
        let lastNameElem = document.querySelector(this.getSelector(".ciLastName"));
        let emailElem = document.querySelector(this.getSelector(".ciEmail"));
        let mobileNumberElem = document.querySelector(this.getSelector(".ciMobileNumber"));
        let zipCodeElem = document.querySelector(this.getSelector(".ciZipCode"));
        let preferedElem = document.querySelector(this.getSelector(".contact-contact-method"));
        let elems = [firstNameElem, lastNameElem, emailElem, mobileNumberElem, zipCodeElem];
        let firstName = firstNameElem.value;
        let lastName = lastNameElem.value;
        let email = emailElem.value;
        let phoneNumber = mobileNumberElem.value;
        let zipCode = zipCodeElem.value;
        elems.forEach((elem) => {
            let elemValue = elem.value;
            if (elemValue.length === 0) {
                validLength = false;
                this.showError(elem);
                this.app.pmDRSDatalayer.validationFailedEvent(PmDRSDatalayer.CONTACT_INFO_SECTION, elem, "required");
                this.fireAdobeDtmFormError();
            } else {
                this.hideError(elem);
            }
        });

        let checkboxTCPA = document.querySelector(this.getSelector("#tcpa-checkbox"));
        let checkboxCCPA = document.querySelector(this.getSelector("#ccpa-checkbox"));
        let preferred = preferedElem.value;
        switch (preferred) {
            case "Phone":
            case "Text Messages":
                if (checkboxCCPA.checked && checkboxTCPA.checked) {
                    document.querySelector(this.getSelector("#tcpa-description")).style.color = "unset";
                    document.querySelector(this.getSelector("#ccpa-description")).style.color = "unset";
                    document.querySelector(this.getSelector(".error-preferred-method")).style.display = "none";
                    document.querySelector(this.getSelector(".error-preferred-method-inline")).style.display = "none";
                    validPreferred = true;
                    // return true;
                }
                break;

            case "Email":
                if (
                    firstName.length > 0 &&
                    email.length > 0 &&
                    lastName.length > 0 &&
                    phoneNumber.length > 0 &&
                    zipCode.length > 0 &&
                    checkboxCCPA.checked
                ) {
                    document.querySelector(this.getSelector("#tcpa-description")).style.color = "unset";
                    document.querySelector(this.getSelector("#ccpa-description")).style.color = "unset";
                    document.querySelector(this.getSelector(".error-preferred-method")).style.display = "none";
                    document.querySelector(this.getSelector(".error-preferred-method-inline")).style.display = "none";
                    validLength = true;
                    validPreferred = true;
                    // return true;
                }
                break;
            case "default":
                document.querySelector(this.getSelector(".error-preferred-method-inline")).style.display = "inline";
                validPreferred = false;
                break;
        }
        if (email.length > 0) {
            if (!FormatHelper.isValidEmail(email)) {
                let mailErrorMsg = "Verify your email";
                document.querySelector(this.getSelector(".error-input.emailField")).innerHTML = mailErrorMsg;
                document.querySelector(this.getSelector(".error-input.emailField")).style.display = "block";

                //DATALAYER
                this.app.pmDRSDatalayer.validationFailedEvent(PmDRSDatalayer.CONTACT_INFO_SECTION, emailElem, "format");
                this.fireAdobeDtmFormError();
                return false;
            }
            validEmail = true;
        }
        if (phoneNumber.length > 0) {
            if (!FormatHelper.isValidPhoneNumber(phoneNumber)) {
                let phoneErrorMsg = "Verify your Phone Number";
                document.querySelector(this.getSelector(".error-input.phoneField")).innerHTML = phoneErrorMsg;
                document.querySelector(this.getSelector(".error-input.phoneField")).style.display = "block";
                //DATALAYER
                this.app.pmDRSDatalayer.validationFailedEvent(
                    PmDRSDatalayer.CONTACT_INFO_SECTION,
                    mobileNumberElem,
                    "format"
                );
                this.fireAdobeDtmFormError();

                return false;
            }
            validPhoneNumber = true;
        }
        // LenderDesk sites send this straight through to the real vendor API as
        // ZipCode (LenderDeskDriver.js:124) with no server-side sanitization — an
        // out-of-format value (e.g. a 13-digit string, since the input is
        // type="number" with no maxlength/digit cap) breaks every LenderDesk
        // payment recalculation for the rest of the session, not just this submit.
        let validZipCode = true;
        if (zipCode.length > 0) {
            if (!FormatHelper.isValidZipCode(zipCode)) {
                validZipCode = false;
                let zipErrorMsg = "Verify your ZIP Code";
                document.querySelector(this.getSelector(".error-input.zipCodeField")).innerHTML = zipErrorMsg;
                document.querySelector(this.getSelector(".error-input.zipCodeField")).style.display = "block";
                //DATALAYER
                this.app.pmDRSDatalayer.validationFailedEvent(
                    PmDRSDatalayer.CONTACT_INFO_SECTION,
                    zipCodeElem,
                    "format"
                );
                this.fireAdobeDtmFormError();

                return false;
            }
        }
        if (!validPreferred) {
            document.querySelector(this.getSelector("#tcpa-description")).style.color = "#790000";
            document.querySelector(this.getSelector("#ccpa-description")).style.color = "#790000";
            if (preferred == "default") {
                document.querySelector(this.getSelector(".error-preferred-method-inline")).style.display = "inline";
            } else {
                // say which box is missing — a bare "This field is required" above the consent text read as nothing happening
                document.querySelector(this.getSelector(".error-preferred-method")).innerHTML = preferred == "Email"
                    ? "Please check the box below to be contacted by email."
                    : "Please check both boxes below to be contacted by " + (preferred == "Phone" ? "phone." : "text message.");
                // Email also lands here when a field above is empty — no consent message if the box is checked
                const consentGiven = checkboxCCPA.checked && (preferred == "Email" || checkboxTCPA.checked);
                document.querySelector(this.getSelector(".error-preferred-method")).style.display = consentGiven ? "none" : "block";
                if (consentGiven) {
                    document.querySelector(this.getSelector("#tcpa-description")).style.color = "unset";
                    document.querySelector(this.getSelector("#ccpa-description")).style.color = "unset";
                }
                document.querySelector(this.getSelector(".error-preferred-method-inline")).style.display = "none";
            }
            // let modal = document.querySelector(".start-deal-container");
            // modal.scrollIntoView({
            //     behavior: "smooth",
            //     block: "end",
            //     inline: "nearest",
            // });
        }

        //DATALAYER
        if (!validPreferred) {
            this.app.pmDRSDatalayer.validationFailedEvent(
                PmDRSDatalayer.CONTACT_INFO_SECTION,
                preferedElem,
                "required"
            );
            this.fireAdobeDtmFormError();
        }

        return validEmail && validLength && validPhoneNumber && validZipCode && validPreferred;
    }

    fireAdobeDtmFormError(){
        if(this.shiftFormErrorSent) return;//skip
        this.app.adobeDtmDatalayer.fireEvent('formError', {errorMessage:'This field is required'});
        this.shiftFormErrorSent = true;
    }

    setTCPA_CCPA() {
        var $this=this;
        // if (this.app.isBMW()) {
        //     // hide lease option. BMW does not handle lease payment option
        //     document.querySelector(this.getSelector(".lease-option div.lease-option")).style.display = "none";
        //     document.querySelector(this.getSelector(".lease-option div.term-lease")).style.display = "none";
        // } else if (this.isBMWPolaris) {
        //     document.querySelector(this.getSelector(".lease-option div.lease-option")).style.display = "none";
        //     document.querySelector(this.getSelector(".lease-option div.term-lease")).style.display = "none";
        //     document.querySelector(this.getSelector(".lease-option div.balloon-option")).style.display = "none";
        //     document.querySelector(this.getSelector(".lease-option div.term-balloon")).style.display = "none";
        //     document.querySelector(this.getSelector(".vehicle-disclaimer")).style.display = "none";
        // } else {
        //     // hide easy ride option
        //     document.querySelector(this.getSelector(".lease-option div.balloon-option")).style.display = "none";
        //     document.querySelector(this.getSelector(".lease-option div.term-balloon")).style.display = "none";
        //     // hide "Disclaimer" text, since that disclaimer is to show Easy Ride information
        //     document.querySelector(this.getSelector(".vehicle-disclaimer")).style.display = "none";
        // }
        var onComplete = function(consents){
            if(!consents){
                console.error('Error getting CCPA and TCPA descriptions');
                //DEFAULTS
                // same keys as the dealer site's pmGetDescriptions (pm-motors-plugin Leads.php)
                $this.consents = {
                    tcpa: `*By checking here, I direct this site to send me text messages to market or advertise products, goods, or services. These text messages may be transmitted through autodialed calls or robotext. By checking the checkbox and
        clicking submit, I confirm that I am the current owner/subscriber of the mobile number provided or that the current owner/subscribed of this mobile phone number authorized me to provide this number to the dealer. I
        understand that my consent is not required as a condition of purchase and that I can revoke my consent at any time. My carrier wireless and text message fees may apply. I will contact the dealer directly to provide
        reasonable notice if I no longer wish to receive automated calls or texts.`,
                    ccpa: `*By submitting this form I understand that this site may contact me with offers or information about their products and service.`
                }
            }else{
                $this.consents = consents;
            }            
            let ccpa = document.querySelector($this.getSelector("#ccpa-description span"));
            let tcpa = document.querySelector($this.getSelector("#tcpa-description span"));
            ccpa.textContent = $this.consents.ccpa;
            tcpa.textContent = $this.consents.tcpa;
        }
        return this.app.pmdrs.pmDealersite.getCCPATCPADescriptions(
            (response) => {
                let consents = JSON.parse(response);                
                // default value
                onComplete(consents);
            },
            (error) => {
                console.log(error);
                onComplete(null);
            }
        );

        // document.querySelector(this.getSelector(".container-tcpa-ccpa")).style.display = "none";
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAtt + " " + selector);
    }

    getSubmitBtn(){
        return document.querySelector(this.app.getSelector(".contact-form-button"));
    }

    setSubmitBtnSent(){
        var btn = this.getSubmitBtn();
        btn.value = 'Sent';
        DOMHelper.addClass(btn, 'submit-sent');
    }

    disable() {
        this.enabled = false;
        DOMHelper.addClass(this.getSelector(".contact-form-input"), "disabled");
        DOMHelper.addClass(this.getSelector("label"), "disabled");        
    }

    enable() {
        this.enabled = true;
        DOMHelper.removeClass(this.getSelector(".contact-form-input"), "disabled");
        DOMHelper.removeClass(this.getSelector("label"), "disabled");        
    }
}
